<template>
  <v-container grid-list-xs fluid>
    <!-- status bars -->
    <v-layout row wrap fill-height>
      <v-flex
        md3
        xs12
        class="pa-4"
        :key="summary.label"
        v-for="summary in summaries"
      >
        <v-card class="elevation-0 shadow" height="100%">
          <v-card-text class="py-1">
            <div class="flex-row justify-space-between">
              <v-avatar
                tile
                size="65"
                style="top:-20px"
                class="shadow-md r5"
                :color="summary.color"
              >
                <v-icon color="white"></v-icon>
              </v-avatar>
              <div class="flex-column align-end text-xs-left">
                <span class="font-weight-bold body-1">{{ summary.label }}</span>
                <strong class="body-2 mt-2">{{ summary.count }}</strong>
              </div>
            </div>
            <v-divider class="my-2"></v-divider>
          </v-card-text>
        </v-card>
      </v-flex>
      <CSOs ref="items" @loaded="setItems" />
    </v-layout>
  </v-container>
</template>
<script>
import CSOs from "../CSOs/index";
export default {
  components: { CSOs },
  name: "dashboard",
  data: () => ({
    items: [],
    current_date: new Date().toISOString().substring(0, 10)
  }),
  computed: {
    summaries: vm => [
      {
        color: "light-blue",
        label: "Assessed CSOs",
        count: vm.items.length
      },
      {
        color: "Pending",
        label: "Pending CSOs",
        count: vm.items.filter(x => x.latest_assessment.decision == "Pending")
          .length
      },
      {
        color: "Certified",
        label: "Certified CSOs",
        count: vm.items.filter(x => x.latest_assessment.decision == "Certified")
          .length
      },
      {
        color: "Deferred",
        label: "Deferred CSOs",
        count: vm.items.filter(x => x.latest_assessment.decision == "Deferred")
          .length
      }
    ]
  },
  methods: {
    setItems(items) {
      this.items = items;
    }
  }
};
</script>
<style>
.dashboard_tile {
  max-width: 400px !important;
}

.left-out {
  left: -17px;
  position: relative;
  min-width: 100px;
  text-align: center;
}
</style>
